import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Bestellung } from '../kaufabwicklung/bestellung.entity';
//#endregion

@Injectable()
export class BestellungService extends ODataEntityService<Bestellung> {
  constructor(protected client: ODataClient) {
    super(client, 'Bestellung', 'kaufabwicklung.Bestellung');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public hasVersandPremium(): ODataFunctionResource<{id: number}, boolean> {
    const resource = this.entities().function<{id: number}, boolean>('services.HasVersandPremium');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
